import React from "react";
import { InputSettingProps } from "../../../../Types/Workflow-Types";
import { Box, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const InputSettingText = ({ header, inputText }: InputSettingProps) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        gap: "8px",
        display: "flex",
        alignItems: "center",
        marginBottom: "16px",
        flexWrap: "wrap",
      }}
    >
      <Box
        sx={{
          width: "24px",
          height: "24px",
          borderRadius: "16px",
          padding: "5px 11px",
          gap: "8px",
          background: "#12B6EA",
          position: "absolute",
          top: "2%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CheckIcon
          sx={{
            width: "18px",
            height: "18px",
            color: "var(--backgroud2)",
          }}
        />
      </Box>
      <Typography
        className="ms-4 ps-2 me-3"
        sx={{
          fontFamily: "Inter",
          fontWeight: "400",
          fontSize: "14px",
          lineHeight: "20px",
          letterSpacing: "0.25px",
          color: "#12B6EA",
          opacity: "0.8",
        }}
      >
        {header}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Roboto",
          fontWeight: "400",
          fontSize: "14px",
          lineHeight: "25px",
          letterSpacing: "0.1px",
          textDecoration: "underline",
          color: "var(--Main_icons_color)",
        }}
      >
        {inputText}
      </Typography>
    </Box>
  );
};

export default InputSettingText;
